import Temporal from "../time/temporal";

export default class QueryMeta {
  constructor(meta) {
    this.meta = meta;
    this.schema = meta?.schema;

    if (meta?.schema) {
      this.schema = meta.schema.reduce((curr, { name, ...rest }, idx) => {
        curr[name] = { idx, ...rest };
        return curr;
      }, {});
    } else {
      this.schema = {};
    }
  }

  get hasFields() {
    return this.fields.length > 0;
  }

  get fields() {
    return this.meta.fields;
  }

  get rowCount() {
    return this.meta.rowCount;
  }

  get totalCount() {
    return this.meta.totalCount;
  }

  get queryStartAt() {
    return this.meta.startAt;
  }

  get queryEndAt() {
    return this.meta.endAt;
  }

  get types() {
    return this.fields.map((f) => this.type(f));
  }

  get fieldTypes() {
    return Object.fromEntries(this.fields.map((f) => [f, this.type(f)]));
  }

  idx(name) {
    return this.schema[name]?.idx;
  }

  type(name) {
    return this.schema[name]?.type;
  }

  shortType(name) {
    const t = this.schema[name]?.type;
    if (t === undefined || t === null) {
      return "UNKNOWN";
    } else if (t.startsWith("tzdatetime")) {
      const zone = t.split(".")[1];
      return `TIME ${Temporal.timezoneAbbreviation(zone)}`;
    } else {
      return {
        json: "json",
        boolean: "bool",
        integer: "int",
        datetime: "time",
        date: "date",
        float: "float",
        string: "str",
      }[t];
    }
  }

  has(name) {
    return !!this.schema[name];
  }
}
